import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-red-700 via-blue-800 to-red-900 text-white px-6 py-10">
      {/* Top Section */}
      <div className="flex flex-col md:flex-row justify-between items-center border-b border-blue-700 pb-6 mb-6 gap-6">
        {/* Logo */}
        <div className="flex items-center gap-2 text-2xl font-bold">
          𝗛𝗧𝗕
          <span className="text-sm md:text-base font-semibold">HTB ACADEMY</span>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 text-sm md:text-base">
          {["Certifications", "Paths", "Modules", "Business", "Academy x HTB Labs", "FAQ", "News", "Sign In"].map((link, i) => (
            <a
              key={i}
              href="#"
              className="hover:text-red-400 transition-colors"
            >
              {link}
            </a>
          ))}
        </nav>

        {/* Button */}
        <div>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-md font-semibold transition">
            Start for Free
          </button>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col md:flex-row justify-between items-center text-gray-300 text-xs md:text-sm gap-4 md:gap-0">
        <p>2020 - 2025 © HTB Academy</p>
        <div className="flex flex-wrap gap-4 md:gap-6">
          {["Terms of Service", "Privacy Policy", "Acceptable Use Policy", "FAQ"].map((link, i) => (
            <a
              key={i}
              href="#"
              className="hover:text-red-400 transition-colors"
            >
              {link}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
